import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import HomebuyerReadinessScore from "@/pages/tools/HomebuyerReadinessScore";

export const Route = createFileRoute("/tools/homebuyer-readiness-score")({
  head: () => seoHead("/tools/homebuyer-readiness-score"),
  component: HomebuyerReadinessScore,
});
